angular.module("app.modalControllers").controller("GenerateJsModalPageController", [
    '$scope',
    '$uibModalInstance',
    '$window',
    'settingsService',
    function ($scope, $modalInstance, $window, settingsService) {

        var settings = settingsService.getSettings();

        $scope.open = function () {
            settings.jsIframeUrl = settings.jsIframeUrl || "http://www.vbet.com/#/?js=http://172.16.79.148/rendered/js/vbet.com.js"
            $window.open(settings.jsIframeUrl, "_blank");
        };

        $scope.ok = function () {
            $modalInstance.close();
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
]);